import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Busca a trilha de auditoria de uma solicitacao (eventos por ordem
 * cronologica). Refaz fetch quando solicitacaoId muda.
 *
 * Retorna { data, loading, error, refetch }.
 */
export function useSolicitacaoEventos(solicitacaoId) {
  const [state, setState] = useState({ data: [], loading: false, error: null });

  const fetchOnce = async (id) => {
    if (!id) {
      setState({ data: [], loading: false, error: null });
      return;
    }
    setState(s => ({ ...s, loading: true, error: null }));
    const { data, error } = await supabase
      .schema('nf')
      .from('solicitacao_eventos')
      .select('*')
      .eq('solicitacao_id', id)
      .order('criado_em', { ascending: true });
    if (error) {
      console.warn('[audit] falha ao buscar eventos', error);
      setState({ data: [], loading: false, error });
      return;
    }
    setState({ data: data || [], loading: false, error: null });
  };

  useEffect(() => {
    let cancelled = false;
    const doFetch = async () => {
      if (cancelled) return;
      await fetchOnce(solicitacaoId);
    };
    doFetch();
    return () => { cancelled = true; };
  }, [solicitacaoId]);

  return {
    ...state,
    refetch: () => fetchOnce(solicitacaoId),
  };
}
